import { useEmailCampaign } from '@/features/campaigns/EmailCampaign/context/useEmailCampaign';

export type { EmailCampaignGate } from '@/features/campaigns/EmailCampaign/context/EmailCampaignProvider';

export const useEmailCampaignGate = () => {
  const ctx = useEmailCampaign();

  return {
    gate: ctx.gate,
    isLoading: ctx.isGateLoading,
    isMailtrapConnected: ctx.isMailtrapConnected,
    hasSendingDomain: ctx.hasSendingDomain,
    hasVerifiedDomain: ctx.hasVerifiedDomain,
    domains: ctx.domains,
  };
};
